export default {
  computed: {
    drawer: {
      get () {
        return this.$store.getters['app/drawer']
      },
      set () { }
    },
    drawerMini: {
      get () {
        return this.$store.getters['app/drawerMini']
      },
      set () { }
    },
    isDark: {
      get () {
        return this.$store.getters['app/isDark']
      },
      set () { }
    },
    site () {
      return site
    },
    isMobile: {
      get () {
        return !!this.$vuetify.breakpoint.mdAndUp
      },
      set () { }
    }
  }
}
